import { MDCTab } from '@material/tab'

export default {
  setup() {
    this.tab = new MDCTab(this.el)
  },
  destroy() {
    this.tab?.destroy()
    this.tab = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
